import { SurveyLocationStatisticsFragment } from '@occc/graphql';

import { SurveyStatisticsBarChartItem, SurveyStatisticsPieChartItem } from './types';
import { SurveyLocationTableBodyExpandableRow } from './SurveyLocationTableBodyExpandableRow';

import { TableBody } from '../../../design-system';

type SurveyLocationsTableBodyProps = {
  data?: Array<SurveyLocationStatisticsFragment>;
  responseStatisticsPerLocationMap: Record<
    string,
    SurveyStatisticsPieChartItem | SurveyStatisticsBarChartItem
  >;
};

export const SurveyLocationsTableBody = ({
  data,
  responseStatisticsPerLocationMap,
}: SurveyLocationsTableBodyProps) => (
  <TableBody>
    {data?.map((location) => (
      <SurveyLocationTableBodyExpandableRow
        key={location.siteId}
        responseStatisticsPerLocation={responseStatisticsPerLocationMap[location.siteId]}
        location={location}
      />
    ))}
  </TableBody>
);
